<script lang="ts" setup>
import { CATALOG_PAGE_TYPES } from '~/constants/catalogPageTypes';
import type { NewResponse } from '~/types/Catalog';

const route = useRoute();
const catalogStore = useCatalogStore();

const newResponse = ref<NewResponse | null>(null);

const data = await catalogStore.getNew();

await processData(data);

async function processData(data: NewResponse | null) {
  if (data) {
    if (import.meta.client) setTimeout(() => window.scrollTo(0, 0), 10);

    catalogStore.currentPageType = CATALOG_PAGE_TYPES.NEW;
    newResponse.value = data;
  }
}

watch(
  () => route.query,
  async () => {
    const data = await catalogStore.getNew();

    await processData(data);
  },
);

useHead({
  title: newResponse.value?.data.seo_data.title,
  meta: [{ name: 'description', content: newResponse.value?.data.seo_data.description }],
});
</script>

<template>
  <section
    v-if="newResponse"
    class="new-page"
  >
    <CatalogBreadcrumbsBlock :breadcrumbs="newResponse.data.breadcrumbs" />

    <h1>{{ newResponse.data.seo_data.header || 'Новинки' }}</h1>

    <ProductsListing
      :filters="newResponse.data.filters"
      :offers="newResponse.data.offers"
      :pagination="newResponse.data.pagination"
      :schema="newResponse.data.schema"
      :sort-options="newResponse.data.sorting_options"
    />
  </section>
</template>

<style lang="scss" scoped>
.new-page {
  @include inner-content;

  gap: 16px;
}
</style>
